exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.languageData-module__edit-language-element___PXbLr {\n    margin-bottom: 5px;\n}\n\n.languageData-module__edit-language-textarea___1tJ5d {\n    margin-top: 10px;\n    margin-bottom: 3px;\n}\n\n.languageData-module__form-group___2H6ZV {\n\n}\n\n.languageData-module__textarea-group___13kWF textarea {\n    resize: vertical;\n    height: 500px;\n    font-size: 13px;\n}\n\n.languageData-module__checkbox___3BDSJ {\n    margin-top: 10px;\n}\n", ""]);

// Exports
exports.locals = {
	"edit-language-element": "languageData-module__edit-language-element___PXbLr",
	"edit-language-textarea": "languageData-module__edit-language-textarea___1tJ5d",
	"form-group": "languageData-module__form-group___2H6ZV",
	"textarea-group": "languageData-module__textarea-group___13kWF",
	"checkbox": "languageData-module__checkbox___3BDSJ"
};